import { Params, Thunk } from '@typings';
import * as services from '@services';
import {
  OrganizationsInvitesState,
  setContext,
  setOrganizationsInvites,
} from '@slices';

import { getConfig } from './config.thunks';

export const getOrganizationsInvites =
  (): Thunk<Promise<OrganizationsInvitesState>> => async (dispatch) => {
    try {
      const invites = await services.getOrganizationsInvites();

      dispatch(setOrganizationsInvites(invites));

      return invites;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const deleteProject =
  ({
    projectName,
    organizationName,
    clusterName,
  }: Params.DeleteProject): Thunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await services.deleteProject({
        projectName,
        organizationName,
        clusterName,
      });

      const {
        projects: [project],
      } = await dispatch(getConfig());

      if (project) {
        dispatch(setContext({ project }));
      }

      return await Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };
